module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><a href = "/#person/'+
((__t=( ownerId ))==null?'':__t)+
'">'+
((__t=( owner ))==null?'':__t)+
'</a></td>\r\n';
 if (showOrganization == true) { 
__p+='\r\n';
 if (organizationId) { 
__p+='\r\n<td><a href = "/#organization/'+
((__t=( organizationId ))==null?'':__t)+
'">'+
((__t=( organization ))==null?'':__t)+
'</a></td>\r\n';
 } else { 
__p+='\r\n<td>-</td>\r\n';
 } 
__p+='\r\n';
 } 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canRead" ';
 if (canRead) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 if (permittedObjectType != 'document') { 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadAll" ';
 if (canReadAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 } 
__p+='\r\n';
 if (permittedObjectType != 'document') { 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadFor" ';
 if (canReadFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 } 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWrite" ';
 if (canWrite) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 if (permittedObjectType != 'document') { 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteFor" ';
 if (canWriteFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 } 
__p+='\r\n';
 if (permittedObjectType != 'document') { 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteAll" ';
 if (canWriteAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 } 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canDelete" ';
 if (canDelete) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canSign" ';
 if (canSign) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 if (showOrganization == true && permittedObjectType != 'document') { 
__p+='\r\n<td><input type="checkbox" value="canSignAll" ';
 if (canSignAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 } 
__p+='\r\n';
 if (permittedObjectType != 'document') { 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canUploadFor" ';
 if (canUploadFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n';
 } 
__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canChangeReviewer" ';
 if (canChangeReviewer) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><span class="glyphicon glyphicon-remove clickable pemission-delete" rel-id="'+
((__t=( id ))==null?'':__t)+
'"/></td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/permissions/permission-row.html
// module id = 239
// module chunks = 0